import { FieldSetContent } from '@nokia-csf-uxr/ccfk/FieldSet';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import Dropbox from '../../Dropbox';
import HelpIcon from '../../HelpIcon';
import ValueInput from '../../ValueInput';
import Form from 'react-bootstrap/esm/Form';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Multipath Outage component
 */
export default class MultiPathOutage extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);
    }

    /**
     * Function is called when the multipath outage norm is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeNorm(link:Readonly<any>, newData: {}) {
        link.define("multipathOutageNorm", newData)
    }

    /**
     * Function is called when the multipath outage prediction is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeMultiPathOutagePred(link:Readonly<any>, newData: {}) {
        link.define("multipathOutagePreds", newData)
    }

    render() {
        return (
        <Container>
            { this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                    <SingleBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>

                                    <Form.Label>Methodology</Form.Label>
                                    <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                        { linkRef?.multipathOutagePreds?.map((multipathOutPred: {idMultiPathOutPred: number, label: string}, index: any) =>
                                            <Form.Check
                                                type="radio"
                                                label={ multipathOutPred.label }
                                                className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                                checked={link?.multipathOutageNorm?.idMultiPathOutPred === multipathOutPred.idMultiPathOutPred}
                                                onChange={() => this.onChangeNorm(link, {index: index, ...multipathOutPred}) }
                                                />
                                        ) }
                                    </FieldSetContent>
                                </Row>
                                <Row className='mt-2'>
                                    { link?.prop_accuracy == "advanced" ? 
                                    <>
                                        <Col xs={6}>
                                            <Form.Label>Propagation conditions <HelpIcon text="Propagation condition map" url="/assets/utils/PropConditionsMap.jpg"/></Form.Label>
                                            <Dropbox 
                                                uniqueKey="idPropCond" 
                                                displayInputKey="label"
                                                showStartedKey={true}
                                                startedKey={link?.multipathOutagePreds?.idPropCond}
                                                values={(linkRef.proConds != null) ? linkRef.proConds : []} 
                                                onChange={(newData) => this.onChangeMultiPathOutagePred(link, newData)}
                                            />
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Label>Fade factor (dB) *</Form.Label>
                                            <ValueInput valueType="float" value={link.fadefactor == null ? 0 : link.fadefactor}
                                                onChange={(data: any) => {
                                                    data = parseFloat(data);
                                                    if(!Number.isNaN(data)) {
                                                        link.define("fadefactor", parseFloat(data))
                                                    } else {
                                                        link.define("fadefactor", 0)
                                                    }
                                                }}  
                                                onBlur={(data: any, error: any) => {
                                                    data = parseFloat(data);
                                                    if(data < 0) {
                                                        error(true);
                                                    }
                                                }}></ValueInput>  
                                                <div className="form-text" style={{fontSize: ".75rem"}}>
                                                * This value will be calculated automatically if you don't set any value
                                                </div>
                                        </Col>

                                    </>
                                    :
                                    <>
                                        <div className="pe-0">
                                        <Form.Label>Propagation conditions <HelpIcon text="Propagation condition map" url="/assets/utils/PropConditionsMap.jpg"/></Form.Label>
                                        <Dropbox 
                                            uniqueKey="idPropCond" 
                                            displayInputKey="label"
                                            showStartedKey={true}
                                            startedKey={link?.multipathOutagePreds?.idPropCond}
                                            values={(linkRef.proConds != null) ? linkRef.proConds : []} 
                                            onChange={(newData) => this.onChangeMultiPathOutagePred(link, newData)}
                                        />
                                        </div>
                                    </> }
                                </Row>
                            </>
                        )}
                    </SingleBandLinkReferenceContext.Consumer>
                    </>
                    )}
                </SingleBandLinkUserContext.Consumer>
            :
                <DualBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                    <DualBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>

                                    <Form.Label>Methodology</Form.Label>
                                    <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                        { linkRef?.multipathOutagePreds?.map((multipathOutPred: {idMultiPathOutPred: number, label: string}, index: any) =>
                                            <Form.Check
                                                type="radio"
                                                label={ multipathOutPred.label }
                                                className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                                checked={link?.multipathOutageNorm?.idMultiPathOutPred === multipathOutPred.idMultiPathOutPred}
                                                onChange={() => this.onChangeNorm(link, {index: index, ...multipathOutPred}) }
                                                />
                                        ) }
                                    </FieldSetContent>
                                </Row>
                                <Row className='mt-2'>
                                    { link?.prop_accuracy == "advanced" ? 
                                    <>
                                        <Col xs={6}>
                                            <Form.Label>Propagation conditions <HelpIcon text="Propagation condition map" url="/assets/utils/PropConditionsMap.jpg"/></Form.Label>
                                            <Dropbox 
                                                uniqueKey="idPropCond" 
                                                displayInputKey="label"
                                                showStartedKey={true}
                                                startedKey={link?.multipathOutagePreds?.idPropCond}
                                                values={(linkRef.proConds != null) ? linkRef.proConds : []} 
                                                onChange={(newData) => this.onChangeMultiPathOutagePred(link, newData)}
                                            />
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Label>Fade factor (dB) *</Form.Label>
                                            <ValueInput valueType="float" value={link.fadefactor == null ? 0 : link.fadefactor}
                                                onChange={(data: any) => {
                                                    data = parseFloat(data);
                                                    if(!Number.isNaN(data)) {
                                                        link.define("fadefactor", parseFloat(data))
                                                    } else {
                                                        link.define("fadefactor", 0)
                                                    }
                                                }}  
                                                onBlur={(data: any, error: any) => {
                                                    data = parseFloat(data);
                                                    if(data < 0) {
                                                        error(true);
                                                    }
                                                }}></ValueInput>  
                                                <div className="form-text" style={{fontSize: ".75rem"}}>
                                                * This value will be calculated automatically if you don't set any value
                                                </div>
                                        </Col>

                                    </>
                                    :
                                    <Col>
                                        <Form.Label>Propagation conditions <HelpIcon text="Propagation condition map" url="/assets/utils/PropConditionsMap.jpg"/></Form.Label>
                                        <Dropbox 
                                            uniqueKey="idPropCond" 
                                            displayInputKey="label"
                                            showStartedKey={true}
                                            startedKey={link?.multipathOutagePreds?.idPropCond}
                                            values={(linkRef.proConds != null) ? linkRef.proConds : []} 
                                            onChange={(newData) => this.onChangeMultiPathOutagePred(link, newData)}
                                        />
                                    </Col> }
                                </Row>
                            </>
                        )}
                    </DualBandLinkReferenceContext.Consumer>
                    </>
                    )}
                </DualBandLinkUserContext.Consumer>
            }
        </Container>
        );
    }

}